import { render, staticRenderFns } from "./upfiles.vue?vue&type=template&id=fc826d48&"
import script from "./upfiles.vue?vue&type=script&lang=js&"
export * from "./upfiles.vue?vue&type=script&lang=js&"
import style0 from "./upfiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc826d48')) {
      api.createRecord('fc826d48', component.options)
    } else {
      api.reload('fc826d48', component.options)
    }
    module.hot.accept("./upfiles.vue?vue&type=template&id=fc826d48&", function () {
      api.rerender('fc826d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tinymce/upfiles.vue"
export default component.exports